import styled from 'styled-components';

export const PullStatsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 30px;
`;
